import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import LoadingSpinner from '../partials/LoadingSpinner';

const UnfulfilledOrderLine = ({ payload, order, searchOrder, setSearchSubmitted, disabled }) => {
  const submitSearch = (orderId) => {
    searchOrder(payload, orderId.replace(/#/g, "").replace(/&/g, "").replaceAll("?", ""));
    setSearchSubmitted(true);
  }

  return(
    <div class="list-element list-element--compact list-element--has-hover list-element--inline-mode">
      <div class="list-element__image">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.743.571a.5.5 0 0 1 .514 0l7.5 4.5A.5.5 0 0 1 17 5.5v7a.5.5 0 0 1-.223.416l-7.5 5a.5.5 0 0 1-.534.013l-7.5-4.5A.5.5 0 0 1 1 13V5.5a.5.5 0 0 1 .243-.429l7.5-4.5zM6.222 3.25l6.528 3.917L15.528 5.5 9 1.583 6.222 3.25zM16 6.383l-6.5 3.9v6.283l6.5-4.334V6.383zM8.5 16.617v-6.334L2 6.383v6.334l6.5 3.9zM2.472 5.5 9 9.417l2.778-1.667L5.25 3.833 2.472 5.5z" fill="currentColor"/></svg>
      </div>
      <div class="list-element__content">
        <div class="list-element__info">
          <div class="list-element__header">
            <div class="list-element__main-info">
              <div class="list-element__title">
                <span>{order.id}</span>
              </div>
              <div class="list-element__description"><span class="muted">{order.createDate}</span></div>
            </div>
            <div class="list-element__price">
              <button
                class="btn btn-default"
                onClick={() => submitSearch(order.id)}
                disabled={disabled}
              >
                Pick Order
              </button>
            </div>
          </div>
          <div class="list-element__data-row">
            { order?.shippingPerson &&
              <span class="spacing--mr1">Shipment: {order.items.length} items shipping to {order?.shippingPerson?.city} {order?.shippingPerson?.stateOrProvinceCode}, {order?.shippingPerson?.countryCode}</span>
            }
            { !order.shippingPerson &&
              <span class="spacing--mr1">{order.items.length} items</span>
            }
          </div>
        </div>
        <div class="list-element__actions">
          <div class="list-element__price">
            <button
              class="btn btn-default"
              onClick={() => submitSearch(order.id)}
              disabled={disabled}
            >
              Pick Order
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(UnfulfilledOrderLine);